export type DutyType = 'FIXO' | 'COBERTURA' | 'EXTRA'

export const dutyTagColors: Record<DutyType, string> = {
  FIXO: 'bg-[#D8EEF3]',
  COBERTURA: 'bg-[rgba(236,162,183,0.6)]',
  EXTRA: 'bg-feedBackSuccess'
}

export const dutyTagBorderColors: Record<DutyType, string> = {
  FIXO: 'border-[#B0D9E3]',
  COBERTURA: 'border-[rgba(236,162,183,0.8)]',
  EXTRA: 'border-green-300'
}

export function getDutyTagBgClass(type: string | undefined): string {
  const key = type?.toUpperCase() as DutyType
  return dutyTagColors[key] || 'bg-primary5'
}

export function getDutyTagBorderClass(type: string | undefined): string {
  const key = type?.toUpperCase() as DutyType
  return dutyTagBorderColors[key] || 'border-primary'
}

const checkOriginLabels: Record<string, string> = {
  DOCTOR: 'App Minha Escala',
  // F2: "Edição plantão" descrevia uma ação que não existe mais (Q4). O que
  // sobrou é o passado lançado à mão, que no ranking da F1 é MANUAL_LEGACY.
  WEB: 'Manual (legado)',
  FOLHA: 'Folha',
  EXTERNAL_APP: 'App externo',
  NON_DAILY_SHEET: 'Folha não diária',
  ACTIVITY_RECORD: 'Registro de Atividade'
}

export function getCheckOriginLabel(origin?: string): string {
  return (origin && checkOriginLabels[origin]) || 'Não identificado'
}

export function humanizeDSReminderStatus(reminderStatus: any): string {
  switch (reminderStatus) {
    case 'PENDING':
      return 'Pendente'
    case 'ACCEPTED':
      return 'Aceito'
    case 'REJECTED':
      return 'Pendente'
    case 'Vazio':
      return 'Vazio'
    default:
      return ''
  }
}
